<template>
  <div class="container">
        <div class="title-container">
            <span>{{ $t('politique-confidentialite.title') }}</span>
        </div>
        <div class="content-container">
            <div v-html="staticTranslations.part1"></div>
            <div v-html="staticTranslations.part2"></div>
            <div v-html="staticTranslations.part3"></div>
            <div v-html="staticTranslations.part4"></div>
            <div v-html="staticTranslations.part5"></div>
            <div v-html="staticTranslations.part6"></div>
            <div v-html="staticTranslations.part7"></div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import frTranslations from '@/locales/fr.json';

export default defineComponent({
    name: 'PolitiqueConfidentialitePage',
    computed: {
        staticTranslations() {
            const politiqueTranslations = frTranslations.filter(t => t.nom.startsWith('politique-confidentialite.content.'));
            return {
                part1: politiqueTranslations.find(t => t.nom === 'politique-confidentialite.content.part1')?.libelle || '',
                part2: politiqueTranslations.find(t => t.nom === 'politique-confidentialite.content.part2')?.libelle || '',
                part3: politiqueTranslations.find(t => t.nom === 'politique-confidentialite.content.part3')?.libelle || '',
                part4: politiqueTranslations.find(t => t.nom === 'politique-confidentialite.content.part4')?.libelle || '',
                part5: politiqueTranslations.find(t => t.nom === 'politique-confidentialite.content.part5')?.libelle || '',
                part6: politiqueTranslations.find(t => t.nom === 'politique-confidentialite.content.part6')?.libelle || '',
                part7: politiqueTranslations.find(t => t.nom === 'politique-confidentialite.content.part7')?.libelle || '',
            };
        }
    }
});
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 24px 24px 0 24px;
}

.title-container {
    color: var(--color-principal);
    font-size: var(--font-size-large);
    font-weight: var(--font-weight-600);
    margin-bottom: 15px;
}

.content-container {
    margin-top: 8px;
    padding: 40px 40px;
    background: white;
    border-radius: 6px;
    margin-bottom: 8px;
}
</style>
